// Lightweight wrapper around FingerprintJS to generate a stable browser/device ID
// Note: Requires dependency: @fingerprintjs/fingerprintjs

let fpAgentPromise: Promise<any> | null = null;

async function loadAgent(): Promise<any | null> {
  try {
    if (!fpAgentPromise) {
      // Dynamic import to avoid SSR/build issues if module missing before install
      fpAgentPromise = import('@fingerprintjs/fingerprintjs')
        .then((mod) => mod.load())
        .catch(() => null);
    }
    return await fpAgentPromise;
  } catch {
    return null;
  }
}

export type FingerprintData = {
  visitorId: string;
  confidence?: number;
};

// agent.get() runs the full entropy probe (canvas, audio, fonts, screen metrics),
// which costs seconds and was previously repeated on every single API request.
// The visitor id is stable for the lifetime of the page, so resolve it once.
let fingerprintPromise: Promise<FingerprintData | null> | null = null;

export function getFingerprint(): Promise<FingerprintData | null> {
  if (!fingerprintPromise) {
    fingerprintPromise = (async () => {
      try {
        const agent = await loadAgent();
        if (!agent) return null;
        const result = await agent.get();
        return {
          visitorId: result.visitorId,
          confidence: result.confidence?.score,
        };
      } catch {
        return null;
      }
    })();
  }

  return fingerprintPromise;
}


